<template>
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      class="v-icon-fill-color"
      d="M8 6 C8.45228 6 9 5.55228 9 5 C9 4.44772 8.45228 4 8 4 C7.44772 4 7 4.44772 7 5 C7 5.55228 7.44772 6 8 6Z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 15.5 C11.866 15.5 15 12.366 15 8.5 C15 4.63401 11.866 1.5 8 1.5 C4.13401 1.5 1 4.63401 1 8.5 C1 12.366 4.13401 15.5 8 15.5Z"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path d="M8 12.5 V8.5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
  </svg>
</template>
